import {createAsyncThunk} from "@reduxjs/toolkit";
import {TWithOptions} from "../../../../../newShared/types";
import {
    GetKycFormQueryVariables,
    RejectKycFormMutationVariables,
    SubmitKycFormMutationVariables
} from "../../../../../newShared/GQLTypes";
import {getKycDictionaries, kycGetFormByTokenApi, kycRejectFormByTokenApi, kycSubmitFormByTokenApi} from "../../api";


export const kycGetFormByTokenAction = createAsyncThunk(
    'KYC/form/kycGetFormByToken',
    async (data: TWithOptions<GetKycFormQueryVariables>, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const {workspaceId, organizationId} = getActionsData(state);

        const resp = await kycGetFormByTokenApi({...data.data}, data.signal);
        data.onSuccess?.(data.data, resp);
        return {
            data: data.data,
            resp
        }
    },
);

export const kycSubmitFormByTokenAction = createAsyncThunk(
    'KYC/form/kycSubmitFormByToken',
    async (data: TWithOptions<SubmitKycFormMutationVariables>, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const {workspaceId, organizationId} = getActionsData(state);

        const resp = await kycSubmitFormByTokenApi({...data.data}, data.signal);
        // const resp = await kycSubmitFormByTokenRestApi({...data.data}, data.signal);

        // if (resp.redirectUrl) {window.parent.location.replace(resp.redirectUrl)}
        data.onSuccess?.(data.data, resp);
        return {
            data: data.data,
            resp
        }
    },
);

export const kycRejectFormByTokenAction = createAsyncThunk(
    'KYC/form/kycRejectFormByToken',
    async (data: TWithOptions<RejectKycFormMutationVariables>, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const {workspaceId, organizationId} = getActionsData(state);

        const resp = await kycRejectFormByTokenApi({...data.data}, data.signal);
        data.onSuccess?.(data.data, resp);
        return {
            data: data.data,
            resp
        }
    },
);




//getKycDictionaries
export const GetKycDictionaries = createAsyncThunk(
    'KycRefactor/getKycDictionaries',
    async () => {
        return await getKycDictionaries();
    }
);
